import { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import emailjs from '@emailjs/browser';
import './Enquiry.css';

const courses = [
  // STOCK MARKET INSTITUTE — Weekend
  { title: 'Technical Analysis',              badge: 'Weekend Course',   price: '₹10,999' },
  { title: 'Fundamental Analysis',            badge: 'Weekend Course',   price: '₹10,999' },
  { title: 'Mutual Fund Investing',           badge: 'Weekend Course',   price: '₹10,999' },
  { title: 'Crypto Trading',                  badge: 'Weekend Course',   price: '₹10,999' },
  // NCFM
  { title: 'Capital Market Module',           badge: 'NCFM',             price: '₹8,999'  },
  { title: 'Options Trading Strategies',      badge: 'NCFM',             price: '₹8,499'  },
  { title: 'Technical Analysis Module',       badge: 'NCFM',             price: '₹8,499'  },
  { title: 'Fundamental Analysis Module',     badge: 'NCFM',             price: '₹8,499'  },
  // NISM
  { title: 'Equity Derivatives Certification',        badge: 'NISM Series VIII', price: '₹8,999'  },
  { title: 'Securities Operations & Risk Management', badge: 'NISM Series VII',  price: '₹9,999'  },
  { title: 'Currency Derivatives Certification',      badge: 'NISM Series I',    price: '₹9,499'  },
  // SPECIAL
  { title: 'Complete Market Mastery Bundle',                              badge: 'Bundle',          price: '₹29,999' },
  { title: 'Advance Diploma in Financial Market Management (ADFMM)',     badge: 'Advanced Diploma', price: '₹99,999' },
];

function validate(form, selectedCourse) {
  const errors = {};
  if (!form.name.trim())
    errors.name = 'Full name is required';
  else if (form.name.trim().length < 3)
    errors.name = 'Name must be at least 3 characters';

  if (!form.mobile.trim())
    errors.mobile = 'Mobile number is required';
  else if (!/^[6-9]\d{9}$/.test(form.mobile.trim()))
    errors.mobile = 'Enter a valid 10-digit Indian mobile number';

  if (!form.email.trim())
    errors.email = 'Email address is required';
  else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email.trim()))
    errors.email = 'Enter a valid email address';

  if (!selectedCourse)
    errors.course = 'Please select a course';

  return errors;
}

function Enquiry() {
  const [searchParams] = useSearchParams();
  const [selectedCourse, setSelectedCourse] = useState('');
  const [selectedBadge,  setSelectedBadge]  = useState('');
  const [selectedPrice,  setSelectedPrice]  = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading,   setLoading]   = useState(false);
  const [errors,    setErrors]    = useState({});

  const [form, setForm] = useState({
    name: '', mobile: '', email: '',
    city: '', occupation: '', experience: '', message: '',
  });

  useEffect(() => {
    const course = searchParams.get('course');
    const badge  = searchParams.get('badge');
    const price  = searchParams.get('price');
    if (course) setSelectedCourse(course);
    if (badge)  setSelectedBadge(badge);
    if (price)  setSelectedPrice(price);
  }, [searchParams]);

  const handleSelect = (course) => {
    setSelectedCourse(course.title);
    setSelectedBadge(course.badge);
    setSelectedPrice(course.price);
    if (errors.course) setErrors(prev => ({ ...prev, course: '' }));
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    if (errors[e.target.name]) {
      setErrors(prev => ({ ...prev, [e.target.name]: '' }));
    }
  };

  const handleSubmit = async () => {
    const validationErrors = validate(form, selectedCourse);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      const firstError = document.querySelector('.enq-error');
      if (firstError) firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    setLoading(true);
    try {
      await emailjs.send(
        'service_w124raa',
        'template_5ha04dn',
        {
          name:       form.name,
          mobile:     form.mobile,
          email:      form.email,
          city:       form.city,
          occupation: form.occupation,
          experience: form.experience,
          course:     selectedCourse,
          message:    form.message || 'No message provided',
        },
        '0jEeQ08-qjREnTQkq'
      );
      setSubmitted(true);
    } catch (error) {
      console.error('EMAIL ERROR:', error);
      alert('Failed to submit enquiry. Please WhatsApp us directly at +91 94302 93305');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="enquiry">
      <div className="enq-inner">

        {/* ── LEFT ── */}
        <div className="enq-left">
          <Link to="/courses" className="enq-back">← Back to Courses</Link>

          <div className="enq-tag">Enrolment</div>
          <h1 className="enq-title">Start Your <span>Market Journey</span></h1>
          <div className="enq-gold-line"></div>
          <p className="enq-sub">Fill in your details and we'll get back to you within 24 hours to confirm your enrolment and share payment details.</p>

          {selectedCourse && (
            <div className="enq-selected">
              <div className="enq-selected-label">Selected Course</div>
              <div className="enq-selected-badge">{selectedBadge}</div>
              <div className="enq-selected-title">{selectedCourse}</div>
              <div className="enq-selected-meta">
                <span>⏱ Lifetime Access</span>
                <span>🗣 Hindi + English</span>
                <span>📜 Exam Prep Included</span>
              </div>
              <div className="enq-selected-price">
                {selectedPrice}<span> / access</span>
              </div>
            </div>
          )}

          <div className="enq-perks">
            <div className="enq-perks-title">What you get</div>
            {[
              'Full course with lifetime access',
              'Live trading sessions with Himanshu sir',
              'NISM / NCFM exam preparation material',
              'Private WhatsApp community access',
              'Doubt clearing sessions every week',
              'Certificate of completion',
            ].map((perk, i) => (
              <div className="enq-perk" key={i}>
                <span className="enq-perk-check">✓</span>
                <span className="enq-perk-text">{perk}</span>
              </div>
            ))}
          </div>
        </div>

        {/* ── RIGHT ── */}
        <div className="enq-right">
          {!submitted ? (
            <>
              <h2 className="enq-form-title">Enquiry Form</h2>
              <p className="enq-form-sub">Fields marked * are required.</p>

              <div className="enq-form">

                <div className="enq-row">
                  <div className="enq-field">
                    <label>Full Name *</label>
                    <input
                      type="text" name="name"
                      placeholder="Your full name"
                      value={form.name} onChange={handleChange}
                      className={errors.name ? 'input-error' : ''}
                    />
                    {errors.name && <span className="enq-error">{errors.name}</span>}
                  </div>
                  <div className="enq-field">
                    <label>Mobile Number *</label>
                    <input
                      type="tel" name="mobile"
                      placeholder="10-digit mobile number"
                      value={form.mobile} onChange={handleChange}
                      maxLength={10}
                      className={errors.mobile ? 'input-error' : ''}
                    />
                    {errors.mobile && <span className="enq-error">{errors.mobile}</span>}
                  </div>
                </div>

                <div className="enq-field">
                  <label>Email Address *</label>
                  <input
                    type="email" name="email"
                    placeholder="your@email.com"
                    value={form.email} onChange={handleChange}
                    className={errors.email ? 'input-error' : ''}
                  />
                  {errors.email && <span className="enq-error">{errors.email}</span>}
                </div>

                <div className="enq-row">
                  <div className="enq-field">
                    <label>City</label>
                    <input
                      type="text" name="city"
                      placeholder="Your city"
                      value={form.city} onChange={handleChange}
                    />
                  </div>
                  <div className="enq-field">
                    <label>Occupation</label>
                    <select name="occupation" value={form.occupation} onChange={handleChange}>
                      <option value="" disabled>Select</option>
                      <option>Student</option>
                      <option>Working Professional</option>
                      <option>Business Owner</option>
                      <option>Homemaker</option>
                      <option>Other</option>
                    </select>
                  </div>
                </div>

                <div className="enq-field">
                  <label>Select Course *</label>
                  <div className="enq-course-grid">
                    {courses.map((c, i) => (
                      <div
                        key={i}
                        className={`enq-course-item ${selectedCourse === c.title ? 'selected' : ''}`}
                        onClick={() => handleSelect(c)}
                      >
                        <div className="enq-course-badge">{c.badge}</div>
                        <div className="enq-course-name">{c.title}</div>
                        <div className="enq-course-price">{c.price}</div>
                      </div>
                    ))}
                  </div>
                  {errors.course && <span className="enq-error">{errors.course}</span>}
                </div>

                <div className="enq-field">
                  <label>Market Experience</label>
                  <select name="experience" value={form.experience} onChange={handleChange}>
                    <option value="" disabled>Select your level</option>
                    <option>Complete Beginner — Never traded before</option>
                    <option>Beginner — Know basics but haven't traded</option>
                    <option>Intermediate — Have some trading experience</option>
                    <option>Advanced — Regular trader looking to upskill</option>
                  </select>
                </div>

                <div className="enq-field">
                  <label>Message (Optional)</label>
                  <textarea
                    name="message" rows="3"
                    placeholder="Any specific questions or requirements..."
                    value={form.message} onChange={handleChange}
                  />
                </div>

                <button
                  type="button"
                  className="enq-submit"
                  onClick={handleSubmit}
                  disabled={loading}
                >
                  {loading ? 'Submitting...' : 'Submit Enquiry'}
                </button>

              </div>
            </>
          ) : (
            <div className="enq-success">
              <div className="enq-success-icon">✓</div>
              <h2 className="enq-success-title">Enquiry Submitted!</h2>
              <p className="enq-success-sub">Thank you! Himanshu sir's team will contact you within 24 hours on your mobile number to confirm enrolment and share payment details.</p>
              <a href="https://wa.me/919430293305" className="enq-wa-btn" target="_blank" rel="noreferrer">
                💬 Or reach us on WhatsApp directly
              </a>
              <Link to="/courses" className="enq-back-btn">← Browse More Courses</Link>
            </div>
          )}
        </div>

      </div>
    </div>
  );
}

export default Enquiry;